import { useState } from 'react'
import type { MediaAsset, Project } from '../../lib/api/types'
import { MediaPanel } from './panels/MediaPanel'
import { LibraryPanel } from './panels/LibraryPanel'
import { TextPanel } from './panels/TextPanel'
import { AiPanel } from './panels/AiPanel'
import { TranscriptPanel } from './panels/TranscriptPanel'
import { BrandKitPanel } from './panels/BrandKitPanel'

type PanelId = 'media' | 'library' | 'text' | 'transcript' | 'ai' | 'brand'

const PANELS: Array<{ id: PanelId; label: string; icon: string }> = [
  { id: 'media', label: 'Mídia', icon: '▦' },
  { id: 'library', label: 'Acervo', icon: '♫' },
  { id: 'text', label: 'Texto', icon: 'T' },
  { id: 'transcript', label: 'Transcrição', icon: '¶' },
  { id: 'ai', label: 'IA', icon: '✦' },
  { id: 'brand', label: 'Marca', icon: '◈' },
]

export function Sidebar({ project, assets }: { project: Project; assets: MediaAsset[] }) {
  const [active, setActive] = useState<PanelId>('media')

  return (
    <aside className="shrink-0 flex border-r border-ink-750">
      <nav className="w-14 shrink-0 bg-ink-900 border-r border-ink-750 flex flex-col py-2 gap-0.5">
        {PANELS.map((panel) => (
          <button
            key={panel.id}
            onClick={() => setActive(panel.id)}
            className={`mx-1 rounded py-2 flex flex-col items-center gap-1 transition-colors
              ${active === panel.id ? 'bg-ink-750 text-accent' : 'text-ink-400 hover:bg-ink-800 hover:text-ink-200'}`}
            aria-pressed={active === panel.id}
            title={panel.label}
          >
            <span className="text-sm leading-none">{panel.icon}</span>
            <span className="text-[9px] leading-none">{panel.label}</span>
          </button>
        ))}
      </nav>

      <div className="w-[300px] shrink-0 bg-ink-850 overflow-y-auto">
        {active === 'media' && <MediaPanel project={project} assets={assets} />}
        {active === 'library' && <LibraryPanel project={project} />}
        {active === 'text' && <TextPanel project={project} />}
        {active === 'transcript' && <TranscriptPanel project={project} assets={assets} />}
        {active === 'ai' && <AiPanel project={project} />}
        {active === 'brand' && <BrandKitPanel project={project} />}
      </div>
    </aside>
  )
}
